export const downloadIcsBlob = (url, fileName = '4boxes_reminders.ics') => {
  const blob = new Blob([url], {
    type: 'text/calendar;charset=utf-8',
  });
  const linkEl = document.createElement('a');
  linkEl.href = window.URL.createObjectURL(blob);
  linkEl.setAttribute('download', fileName);
  document.body.appendChild(linkEl);
  linkEl.click();
  document.body.removeChild(linkEl);
};
